import { render } from "./choosecontract.vue?vue&type=template&id=0dfb86da"
import script from "./choosecontract.vue?vue&type=script&lang=js"
export * from "./choosecontract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__